function stickyheaderLoadInit() {
  const headerSection = document.querySelector('.main-header-top');
  const sourceHeader = headerSection && headerSection.querySelector('header[data-header-main]');
  if (!headerSection || !sourceHeader) return;

  const stickyEnabled = sourceHeader.getAttribute('data-sticky-header') === 'true';
  const stickyType = sourceHeader.getAttribute('data-header-type');
  if (!stickyEnabled) return;

  /* PNJ 26-AUG — TIFFANY COMPACT v2
     Header grande natural + una sola barra compacta independiente.
     La compacta se construye SOLO con navegación + iconos para evitar menús duplicados. */
  headerSection.classList.remove('stickytrue', 'sticky-header-hidden', 'sticky-header-active');
  headerSection.classList.add('pnj-full-header-natural');

  document.querySelectorAll('.pnj-tiffany-compact').forEach((el) => el.remove());

  const sourceNav = sourceHeader.querySelector('.nav-main-wrapper');
  const sourceIcons = sourceHeader.querySelector('.icons-inline');
  if (!sourceNav) return;

  const compact = document.createElement('div');
  compact.className = 'pnj-tiffany-compact';
  compact.setAttribute('aria-hidden', 'true');

  const shell = document.createElement('div');
  shell.className = 'pnj-tiffany-shell';

  /* PNJ 28-AUG — Botón hamburguesa visible también en la barra compacta móvil.
     Reutiliza el drawer nativo del tema para mantener toda la navegación existente. */
  const sourceHamburger = sourceHeader.querySelector('[data-hamburger-mobile]');
  if (sourceHamburger) {
    const mobileMenuTrigger = document.createElement('div');
    mobileMenuTrigger.className = 'pnj-tiffany-mobile-menu-trigger';
    const hamburger = sourceHamburger.cloneNode(true);
    hamburger.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
    /* El botón de la barra compacta usa su propio controlador.
       Así evitamos que el inicializador nativo se enganche dos veces y abra un panel vacío. */
    hamburger.removeAttribute('data-hamburger-mobile');
    hamburger.setAttribute('data-pnj-compact-hamburger', '');
    hamburger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      const drawer = document.querySelector('#mobile-nav-menu');
      if (!drawer) return;
      const opening = !drawer.classList.contains('active');
      document.body.classList.toggle('mobile-menu-active', opening);
      document.body.classList.toggle('no-scroll', opening);
      drawer.classList.toggle('active', opening);
      hamburger.classList.toggle('active', opening);
      drawer.setAttribute('aria-hidden', opening ? 'false' : 'true');
    });
    mobileMenuTrigger.appendChild(hamburger);
    shell.appendChild(mobileMenuTrigger);
  }

  const navWrap = document.createElement('div');
  navWrap.className = 'pnj-tiffany-nav';
  const nav = sourceNav.cloneNode(true);
  nav.classList.add('pnj-tiffany-nav-inner');
  nav.querySelectorAll('.dropdown-menus-outer, .site-nav-submenu, .mega-menu-wrapper, .megamenu-wrapper, .mega-menu, [class*="dropdown-wrapper"]').forEach((el) => el.remove());
  nav.querySelectorAll('svg').forEach((el) => el.remove());
  nav.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
  nav.querySelectorAll('[data-model-main-head], [data-sideDrawer-open], [data-id]').forEach((el) => {
    el.removeAttribute('data-model-main-head');
    el.removeAttribute('data-sideDrawer-open');
    el.removeAttribute('data-id');
  });
  navWrap.appendChild(nav);
  shell.appendChild(navWrap);

  if (sourceIcons) {
    const iconsWrap = document.createElement('div');
    iconsWrap.className = 'pnj-tiffany-icons';
    const icons = sourceIcons.cloneNode(true);
    icons.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
    icons.querySelectorAll('[data-model-main-head], [data-sideDrawer-open], [data-id]').forEach((el) => {
      el.removeAttribute('data-model-main-head');
      el.removeAttribute('data-sideDrawer-open');
      el.removeAttribute('data-id');
    });
    iconsWrap.appendChild(icons);
    shell.appendChild(iconsWrap);
  }

  compact.appendChild(shell);
  document.body.appendChild(compact);

  let lastY = Math.max(0, window.scrollY);
  let visible = false;
  let ticking = false;
  let direction = 0;
  let intent = 0;
  const SHOW_AFTER = 130;
  const TOP_ZONE = 18;
  const INTENT_PX = 18;

  function showCompact() {
    if (visible || window.scrollY < SHOW_AFTER) return;
    visible = true;
    compact.classList.add('is-visible');
    compact.setAttribute('aria-hidden', 'false');
  }

  function hideCompact() {
    if (!visible) return;
    visible = false;
    compact.classList.remove('is-visible');
    compact.setAttribute('aria-hidden', 'true');
  }

  hideCompact();

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const y = Math.max(0, window.scrollY);
      const delta = y - lastY;

      if (y <= TOP_ZONE) {
        hideCompact();
        direction = 0;
        intent = 0;
        lastY = y;
        ticking = false;
        return;
      }

      if (Math.abs(delta) >= 0.5) {
        const nextDirection = delta > 0 ? 1 : -1;
        if (nextDirection !== direction) {
          direction = nextDirection;
          intent = 0;
        }
        intent += Math.abs(delta);

        if (stickyType === 'always') {
          if (y >= SHOW_AFTER) showCompact();
        } else if (intent >= INTENT_PX) {
          if (direction < 0 && y >= SHOW_AFTER) showCompact();
          if (direction > 0) hideCompact();
          intent = 0;
        }
      }

      lastY = y;
      ticking = false;
    });
  }, { passive: true });
}

function mobileHumburgerMenuInit() {
    let mobileHumburgerElements = document.querySelectorAll('[data-hamburger-mobile]');
    let headerMainParent = document.querySelector('header');
    let body = document.querySelector('body');

    Array.from(mobileHumburgerElements).forEach(function(element) {
        element.addEventListener("click", function(event) {
           event.preventDefault();  
          let drawerElement =  element.getAttribute("href");
          let contentDrawerContainer= document.querySelector(drawerElement);
             if(element.classList.contains('active')){
                if (body.classList.contains('mobile-menu-active')) {
                    body.classList.remove('no-scroll', 'mobile-menu-active');
                    contentDrawerContainer.classList.remove('active');
                  element.classList.remove('active');
                }
             }else{
                    element.classList.add('active');
                    body.classList.add('no-scroll', 'mobile-menu-active');
                    contentDrawerContainer.classList.add('active');
              } 
        });
        
    })
    window.addEventListener("resize", function() {
        if (window.innerWidth > 991 && body.classList.contains('mobile-menu-active')) {
            body.classList.remove('mobile-menu-active', 'no-scroll');
            contentDrawerContainer.classList.remove('show');
        }
    })
}
function mobileMenuitemsEvent() {

  let mobileMenus = document.querySelectorAll(".mobile-menus-item");
    Array.from(mobileMenus).forEach(function(mobileMenu){
      mobileMenu.addEventListener("click",function(event){
        if(mobileMenu){
          mobileMenu.closest("[data-child-items]").classList.add("active")
        }
        
      })
    })
    let backToNavElemets = document.querySelectorAll("[data-backtonav-items],[data-subbacktonav-items]");
    Array.from(backToNavElemets).forEach(function(navBarbackElement) {
        navBarbackElement.addEventListener("click", function(event) {
          if(event.target.closest('details').hasAttribute("open")){
            event.target.closest('details[open]').removeAttribute("open");
            event.target.closest('[data-child-items].active').classList.remove("active");
            //mobileMenuitemsEvent();
          }      
        })
    })

}

document.addEventListener('DOMContentLoaded',  function (section = document) {
  stickyheaderLoadInit();
  mobileHumburgerMenuInit();
  mobileMenuitemsEvent();
});

document.addEventListener('shopify:section:load',function (section) {
     let sectiontargetHead = section.target;
    stickyheaderLoadInit(sectiontargetHead);
    mobileHumburgerMenuInit(sectiontargetHead);
    mobileMenuitemsEvent(sectiontargetHead);
});


/* PNJ — navegación del header siempre clickeable (25-AUG-2026).
   Usa fase capture para evitar que animaciones/megamenú cancelen el enlace real. */
function pnjHeaderNavigationClickFix() {
  if (window.__pnjHeaderNavigationClickFix) return;
  window.__pnjHeaderNavigationClickFix = true;

  document.addEventListener('click', function (event) {
    const link = event.target && event.target.closest ? event.target.closest('.main-header-top .site-nav-link') : null;
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href || href === '#' || href.startsWith('javascript:')) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) return;

    /* PNJ 12-SEP-2026 — móvil: el TEXTO de la categoría navega con un toque.
       La flecha/área restante del summary sigue abriendo el submenú. */
    if (window.innerWidth <= 991 && link.closest('.drawer-mobile-menu')) {
      const summary = link.closest('summary');
      if (summary) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(link.href);
        return;
      }
    }

    /* Los links del menú principal deben navegar inmediatamente, incluso si otro script
       del tema intenta tratar el click como apertura de submenú. */
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(link.href);
  }, true);
}

document.addEventListener('DOMContentLoaded', pnjHeaderNavigationClickFix);
if (document.readyState !== 'loading') pnjHeaderNavigationClickFix();


/* PNJ 11-SEP-2026 — LOGO A INICIO EN UN SOLO CLICK/TOQUE
   Se ejecuta en captura para que ningún hover, sticky header, buscador o mega menú
   consuma el primer click. Funciona igual en desktop y móvil. */
function pnjLogoOneClickHomeFix() {
  if (window.__pnjLogoOneClickHomeFix) return;
  window.__pnjLogoOneClickHomeFix = true;

  function isModified(event) {
    return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1;
  }

  document.addEventListener('click', function (event) {
    const logo = event.target && event.target.closest ? event.target.closest('.main-header-top .logo-image') : null;
    if (!logo || !logo.href || isModified(event)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(logo.href);
  }, true);

  /* En móvil empezamos a calentar Inicio desde el primer contacto, sin bloquear el toque. */
  document.addEventListener('pointerdown', function (event) {
    const logo = event.target && event.target.closest ? event.target.closest('.main-header-top .logo-image') : null;
    if (!logo || !logo.href || logo.dataset.pnjHomeWarmed === '1') return;
    logo.dataset.pnjHomeWarmed = '1';
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = logo.href;
    document.head.appendChild(link);
  }, {capture:true, passive:true});
}

document.addEventListener('DOMContentLoaded', pnjLogoOneClickHomeFix);
if (document.readyState !== 'loading') pnjLogoOneClickHomeFix();


/* PNJ 10-SEP-2026 — NAVEGACIÓN DE COLECCIONES LIGERA
   Solo precarga al pasar el mouse o enfocar un enlace.
   Se eliminó la precarga automática masiva porque competía con las imágenes de productos. */
(function pnjLightCollectionNavigation(){
  if (window.__pnjLightCollectionNavigation) return;
  window.__pnjLightCollectionNavigation = true;
  const prefetched = new Set();
  function warm(a){
    if (!a || !a.href) return;
    let u;
    try { u = new URL(a.href, location.href); } catch(e) { return; }
    if (u.origin !== location.origin || u.pathname.indexOf('/collections/') !== 0) return;
    const url = u.href;
    if (prefetched.has(url) || url === location.href) return;
    prefetched.add(url);
    const l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    document.head.appendChild(l);
  }
  document.addEventListener('pointerenter', function(e){
    const a = e.target && e.target.closest ? e.target.closest('.main-header-top a[href*="/collections/"]') : null;
    if (a) warm(a);
  }, true);
  document.addEventListener('focusin', function(e){
    const a = e.target && e.target.closest ? e.target.closest('.main-header-top a[href*="/collections/"]') : null;
    if (a) warm(a);
  });
})();

/* =========================================================
   PNJ 12-SEP-2026 — TOQUE DIRECTO REAL EN MÓVIL
   Evita que el primer toque sea consumido por :hover/segunda imagen.
   Foto + nombre de producto y logo navegan en el primer toque.
   No interfiere cuando el usuario está desplazando la página.
   ========================================================= */
(function pnjDirectMobileTapNavigation(){
  if (window.__pnjDirectMobileTapNavigationV2) return;
  window.__pnjDirectMobileTapNavigationV2 = true;

  let startX = 0, startY = 0, moved = false, activeLink = null;

  function eligibleLink(target){
    if (!target || !target.closest) return null;
    const a = target.closest(
      'product-card a[data-main-image], product-card a.product-name, .main-header-top a.logo-image'
    );
    if (!a || !a.href) return null;
    try {
      const u = new URL(a.href, window.location.href);
      if (u.origin !== window.location.origin) return null;
    } catch(e){ return null; }
    return a;
  }

  document.addEventListener('touchstart', function(e){
    if (!e.touches || e.touches.length !== 1) { activeLink = null; return; }
    const a = eligibleLink(e.target);
    if (!a) { activeLink = null; return; }
    activeLink = a;
    moved = false;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, {capture:true, passive:true});

  document.addEventListener('touchmove', function(e){
    if (!activeLink || !e.touches || !e.touches.length) return;
    const dx = Math.abs(e.touches[0].clientX - startX);
    const dy = Math.abs(e.touches[0].clientY - startY);
    if (dx > 10 || dy > 10) moved = true;
  }, {capture:true, passive:true});

  document.addEventListener('touchend', function(e){
    if (!activeLink) return;
    const a = activeLink;
    activeLink = null;
    if (moved) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.assign(a.href);
  }, {capture:true, passive:false});
})();

/* PNJ 12-SEP-2026 — submenús móviles separados del enlace.
   TEXTO = navega inmediatamente. FLECHA = acordeón suave. */
(function pnjMobileAccordionOneTap(){
  if (window.__pnjMobileAccordionOneTap) return;
  window.__pnjMobileAccordionOneTap = true;

  document.addEventListener('click', function(event){
    const btn = event.target && event.target.closest ? event.target.closest('.drawer-mobile-menu .pnj-mobile-submenu-toggle') : null;
    if (!btn) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    const item = btn.closest('.site-nav-item');
    if (!item) return;
    const opening = !item.classList.contains('pnj-submenu-open');

    /* En el mismo nivel, cierra otros acordeones para mantener el menú limpio. */
    const parentList = item.parentElement;
    if (opening && parentList) {
      Array.from(parentList.children).forEach(function(sibling){
        if (sibling !== item && sibling.classList && sibling.classList.contains('pnj-submenu-open')) {
          sibling.classList.remove('pnj-submenu-open');
          const other = sibling.querySelector(':scope > .pnj-mobile-nav-row > .pnj-mobile-submenu-toggle');
          if (other) other.setAttribute('aria-expanded','false');
        }
      });
    }

    item.classList.toggle('pnj-submenu-open', opening);
    btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
  }, true);
})();




/* =========================================================
   PNJ 14-SEP-2026 — CATEGORÍAS MÓVIL: NAVEGACIÓN NATIVA 1 TOQUE
   No usamos hover para las categorías en pantallas táctiles. El enlace
   recibe el toque directamente y navega; la flecha del drawer conserva
   su función independiente de abrir submenús.
   ========================================================= */
(function pnjMobileCategoryNativeOneTap(){
  if (window.__pnjMobileCategoryNativeOneTap) return;
  window.__pnjMobileCategoryNativeOneTap = true;

  function isMobile(){
    return window.matchMedia('(max-width: 991px)').matches;
  }

  function directLinkFromTarget(target){
    if (!isMobile() || !target || !target.closest) return null;
    var a = target.closest(
      '.main-header-top .nav-main-wrapper .navbar-nav > .site-nav-item > a.site-nav-link,' +
      '.main-header-top .drawer-mobile-menu a.pnj-mobile-direct-link'
    );
    if (!a || !a.href) return null;
    if (target.closest('.pnj-mobile-submenu-toggle')) return null;
    try {
      var u = new URL(a.href, location.href);
      if (u.origin !== location.origin) return null;
    } catch(e){ return null; }
    return a;
  }

  /* pointerup funciona de forma consistente en iOS/Android modernos y no
     se dispara hasta terminar el toque, por lo que un gesto de scroll no
     se convierte en navegación accidental. */
  var downX = 0, downY = 0, downLink = null;
  document.addEventListener('pointerdown', function(e){
    if (!isMobile() || e.pointerType === 'mouse') return;
    downLink = directLinkFromTarget(e.target);
    if (!downLink) return;
    downX = e.clientX; downY = e.clientY;
  }, true);

  document.addEventListener('pointerup', function(e){
    if (!downLink || !isMobile() || e.pointerType === 'mouse') return;
    var a = downLink; downLink = null;
    if (Math.abs(e.clientX-downX) > 10 || Math.abs(e.clientY-downY) > 10) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    /* Conserva la posición horizontal de la barra móvil para evitar el
       salto brusco al cargar la colección siguiente. */
    try {
      var nav = document.querySelector('.main-header-top .nav-main-wrapper');
      if (nav) sessionStorage.setItem('pnjMobileNavScrollLeft', String(nav.scrollLeft || 0));
    } catch(err) {}
    location.assign(a.href);
  }, true);

  document.addEventListener('pointercancel', function(){ downLink = null; }, true);

  /* Restaura la barra horizontal sin animación al llegar a la nueva página.
     Así el header no salta hacia la primera categoría durante la navegación. */
  function restoreMobileNavPosition(){
    if (!isMobile()) return;
    try {
      var saved = sessionStorage.getItem('pnjMobileNavScrollLeft');
      if (saved === null) return;
      var nav = document.querySelector('.main-header-top .nav-main-wrapper');
      if (!nav) return;
      var oldBehavior = nav.style.scrollBehavior;
      nav.style.scrollBehavior = 'auto';
      nav.scrollLeft = parseFloat(saved) || 0;
      requestAnimationFrame(function(){ nav.style.scrollBehavior = oldBehavior; });
    } catch(err) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreMobileNavPosition, {once:true});
  } else {
    restoreMobileNavPosition();
  }
})();
